import { render, staticRenderFns } from "./FilterRoleDropdown.vue?vue&type=template&id=e6201340&lang=pug&"
import script from "./FilterRoleDropdown.vue?vue&type=script&lang=js&"
export * from "./FilterRoleDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports